import React, {Component} from 'react';
import { TimeGridItem } from '../TimeGrid';
//import moment  from 'moment';
//import Clinic from '../../api/Clinic';
//import { AppointmentService } from '../../api/Service';
import StatusIcon from '../../components/StatusIcon';
//import User from '../../api/User';
import Appointment from '../../api/Appointment';
//import { SanitizeClassNames } from '../../common';
import { NotificationManager } from 'react-notifications';
//import Clinic from

import Hammer from 'react-hammerjs';
import ColorHelper from "../../classes/ColorHelper";

const prefIcon = {
	email: 'email',
	cell: 'text',
	phone: 'call',
	work: 'call',
	PHON: 'call',
	SMSM: 'text',
	EMAL: 'email'
};


export default class AppCalendarCell extends TimeGridItem{
	static colors = [
		'#F9A14A',
		'#5D4DA1',
		'#C1198B',
		'#42A444'
	];

	state = {};


	formatTime(time){

		let format =  'h:mm a';
		if(time.minute() == 0){
			format = 'h a';
		}

		return time.format(format);

	}

	onStart(pos){
		this.oldPos = pos;
	}

	onMove(pos){
		let start = this.props.grid.getTimeFromRow(pos.y);
		let end = this.props.grid.getTimeFromRow(pos.y + pos.h)
		this.setState({timeStart:start, timeEnd:end});
	}

	onDrop(pos, isUndo){
		//let start = this.grid.getTimeFromRow(pos.y);
		//let end = this.grid.getTimeFromRow(pos.y + pos.h)
		//this.updateAppTime(start, end);
		console.log('AppCalendar Cell Drop !!!!!!!!')

		if(this.props.onUpdateApp){
			this.setState({isBusy:true});
			//let oldApp = JSON.parse(JSON.stringify(this.props.appointment));
			let promise = this.props.onUpdateApp(this.props.appointment, pos);
			if(!promise) {
				this.onDrop(this.oldPos, true)
				this.setState({isBusy:false});
				return;
			}
			promise.then((d)=> {
				console.log('App Update Complete', d);

				for(let p in d){
					this.props.appointment[p] = d[p];
				}
				this.setState({isBusy:false});
				if(!isUndo){
					NotificationManager.success(
						<div>
                            <span className='app-undo-btn' onClick={()=>{
	                            this.onDrop(this.oldPos, true)
                            }}>UNDO
                            </span>
							<div className='notification-close-btn'>x</div>
						</div>

						, 'Appointment Updated!', 5000);

				}else{
					NotificationManager.warning(<div>
						<span>Appointment Reverted!</span>
						<div className='notification-close-btn'>x</div>
					</div>);
				}
			})
			/*for(let i=0 ; i < this.props.appointment.length; i++){
				this.props.onUpdateApp(this.props.appointment[i], pos, true);
			} */
		}
	}


	handleSelect = (e) => {
		e.preventDefault();
		if(this.props.onSelect){
			this.props.onSelect(this.props.appointment);
		}
	}


	/*
		render(){

			let appCells = [];
			let apps = this.appointments;
			let time = null;
			if(this.state.timeStart){
				time = this.formatTime(this.state.timeStart) + " - " + this.formatTime(this.state.timeEnd);
			} else{
				time = Appointment.FormatTimeRange(apps[0]);
			}


			let app = this.props.appointment;

			return(
				<div key={this.__id} className={"calendar-item"} grid-item={this.props['grid-item']} title={time}>
					<div className='table layout-fixed vmax hmax'>
						<div><AppCellView app={new Appointment(app)} onDoubleClick={() => this.handleSelect(app)}   /></div>
					</div>
					<div className="time">{time}</div>
				</div>
			)
		}
	*/
	render(){
		//let time = this.formatTime(this.state.timeStart) + " - " + this.formatTime(this.state.timeEnd);
		let time = null;
		let app = new Appointment(this.props.appointment);
		let user = app.client;
		if(this.state.timeStart){
			time = this.formatTime(this.state.timeStart) + " - " + this.formatTime(this.state.timeEnd);
		} else{
			time = Appointment.FormatTimeRange(app);
		}

		let inverse = ColorHelper.GetInverse('#' + app.appointmentType.color);
		let style = {
			backgroundColor:'#' + app.appointmentType.color,
			color: inverse,
			textShadow: "0px 0px 3px " + ColorHelper.GetInverse(inverse)
		}

		let reminder = (app.reminders || [])[0] || {};

		let contactMethod = prefIcon[reminder.notificationTypeCd]; //prefIcon[user.preferredContactMethod];
		return (
			<div key={this.__id} className="calendar-item" style={style} grid-item={this.props['grid-item']}>
				<div className="name">{user.fullName}</div>
				<div className="time">{time}</div>
				<StatusIcon icon={contactMethod} status={app.status}/>
				{this.state.isBusy ? <span className="Select-loading"></span> : null}
			</div>
		)
	}
}

/*class AppCellView extends Component{

    render(){
        let {app, ...props} = this.props;

        let user = app.client;
        let contactMethod = prefIcon[user.preferredContactMethod];
        let style = {
            backgroundColor: '#' + app.appointmentType.color
        }
        return(
            <div className={SanitizeClassNames(this, 'app-detail')} style={style} {...props}>
                <div className="name">{user.fullName}</div>
                <StatusIcon icon={contactMethod} status={app.status} />
            </div>
        )
    }
}*/



// WEBPACK FOOTER //
// ./src/views/Appointments/AppCalendarCell.js